<template>
  <section>
    <div class="l-service">
      <div class="l-service-header">
        <h2 class="heading-default heading-default-center">IRカレンダー</h2>
        <h3 class="heading-small heading-small-center heading-small-mt-sp">
          IR CALENDAR
        </h3>

        <div class="l-service-content-inner">
          <!-- E-IR Parts -->
          <div id="doEirWrapper"></div>
          <div id="eirArea"></div>
          <!-- /E-IR Parts -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "IRカレンダー",
      titleTemplate: "IRカレンダー | IR情報 | 株式会社 旅工房",
    };
  },
  mounted: function () {
    this.$nextTick(() => {
      let doEirWrapper = document.getElementById("doEirWrapper");
      let doEirScript = document.createElement("script");
      doEirScript.innerHTML = 'setParts("schedule")';
      doEirWrapper.appendChild(doEirScript);
    });
  },
};
</script>
